import { createContext } from "react";



export const SelectRamlContext=createContext()